import _ from 'lodash';
import { validateNumber } from './numericalValidation';
var paramType = ['string', 'boolean', 'float', 'integer', 'multi_selection', 'multi_string', 'radio'];
var geometryType = ['rectangle', 'line', 'direction', 'polygon', 'polyline'];
var envConfig = {
  "ivaDocs": {
    "event_search_rule_all_en": {
      ".htm": "event_search_rule_all_en.htm"
    },
    "event_search_rule_all_ja": {
      ".htm": "event_search_rule_all_ja.htm"
    },
    "event_search_rule_all_th": {
      ".htm": "event_search_rule_all_th.htm"
    },
    "event_search_rule_all_zh": {
      ".htm": "event_search_rule_all_zh.htm"
    },
    "event_search_rule_en": {
      ".htm": "event_search_rule_en.htm"
    },
    "event_search_rule_ja": {
      ".htm": "event_search_rule_ja.htm"
    },
    "event_search_rule_th": {
      ".htm": "event_search_rule_th.htm"
    },
    "event_search_rule_zh": {
      ".htm": "event_search_rule_zh.htm"
    },
    "event_subscribe_desc_en": {
      ".htm": "event_subscribe_desc_en.htm"
    },
    "event_subscribe_desc_ja": {
      ".htm": "event_subscribe_desc_ja.htm"
    },
    "event_subscribe_desc_th": {
      ".htm": "event_subscribe_desc_th.htm"
    },
    "event_subscribe_desc_zh": {
      ".htm": "event_subscribe_desc_zh.htm"
    },
    "help_feature_color_enable_en": {
      ".htm": "help_feature_color_enable_en.htm"
    },
    "help_feature_color_enable_ja": {
      ".htm": "help_feature_color_enable_ja.htm"
    },
    "help_feature_color_enable_th": {
      ".htm": "help_feature_color_enable_th.htm"
    },
    "help_feature_color_enable_zh": {
      ".htm": "help_feature_color_enable_zh.htm"
    },
    "help_fr_custom_threshold_en": {
      ".htm": "help_fr_custom_threshold_en.htm"
    },
    "help_fr_custom_threshold_ja": {
      ".htm": "help_fr_custom_threshold_ja.htm"
    },
    "help_fr_custom_threshold_th": {
      ".htm": "help_fr_custom_threshold_th.htm"
    },
    "help_fr_custom_threshold_zh": {
      ".htm": "help_fr_custom_threshold_zh.htm"
    },
    "help_fr_output_mode_en": {
      ".htm": "help_fr_output_mode_en.htm"
    },
    "help_fr_output_mode_ja": {
      ".htm": "help_fr_output_mode_ja.htm"
    },
    "help_fr_output_mode_th": {
      ".htm": "help_fr_output_mode_th.htm"
    },
    "help_fr_output_mode_zh": {
      ".htm": "help_fr_output_mode_zh.htm"
    },
    "help_iod_output_mode_en": {
      ".htm": "help_iod_output_mode_en.htm"
    },
    "help_iod_output_mode_ja": {
      ".htm": "help_iod_output_mode_ja.htm"
    },
    "help_iod_output_mode_th": {
      ".htm": "help_iod_output_mode_th.htm"
    },
    "help_iod_output_mode_zh": {
      ".htm": "help_iod_output_mode_zh.htm"
    },
    "help_login_auth_en": {
      ".htm": "help_login_auth_en.htm"
    },
    "help_login_auth_ja": {
      ".htm": "help_login_auth_ja.htm"
    },
    "help_login_auth_th": {
      ".htm": "help_login_auth_th.htm"
    },
    "help_login_auth_zh": {
      ".htm": "help_login_auth_zh.htm"
    },
    "help_thermal_and_blackbody_config_en": {
      ".htm": "help_thermal_and_blackbody_config_en.htm"
    },
    "help_thermal_and_blackbody_config_ja": {
      ".htm": "help_thermal_and_blackbody_config_ja.htm"
    },
    "help_thermal_and_blackbody_config_th": {
      ".htm": "help_thermal_and_blackbody_config_th.htm"
    },
    "help_thermal_and_blackbody_config_zh": {
      ".htm": "help_thermal_and_blackbody_config_zh.htm"
    },
    "iva_faq_en": {
      ".htm": "iva_faq_en.htm"
    },
    "iva_faq_ja": {
      ".htm": "iva_faq_ja.htm"
    },
    "iva_faq_th": {
      ".htm": "iva_faq_th.htm"
    },
    "iva_faq_zh": {
      ".htm": "iva_faq_zh.htm"
    },
    "str_ipm_loitering_sensitivity_desc_en": {
      ".htm": "str_ipm_loitering_sensitivity_desc_en.htm"
    },
    "str_ipm_loitering_sensitivity_desc_ja": {
      ".htm": "str_ipm_loitering_sensitivity_desc_ja.htm"
    },
    "str_ipm_loitering_sensitivity_desc_th": {
      ".htm": "str_ipm_loitering_sensitivity_desc_th.htm"
    },
    "str_ipm_loitering_sensitivity_desc_zh": {
      ".htm": "str_ipm_loitering_sensitivity_desc_zh.htm"
    },
    "system_info_en": {
      ".htm": "system_info_en.htm"
    },
    "system_info_ja": {
      ".htm": "system_info_ja.htm"
    },
    "system_info_th": {
      ".htm": "system_info_th.htm"
    },
    "system_info_zh": {
      ".htm": "system_info_zh.htm"
    }
  }
};

function getConfig(key, defaultVal) {
  var _cfg = {
    envConfig: envConfig
  };
  var cfg = _cfg;
  if (!key) return cfg;
  return _.get(cfg, key, defaultVal);
} // function getConditionJson(cid, sid, cond) {
//     let layout = { cid, sid, geoItems: [] }
//     console.log('hl cond: ', cond)
//     // XML object to geoItem's parameter object
//     const getParamJson = (param) => {
//         let jsonObj = {}
//         jsonObj['pid'] = param.$.id
//         jsonObj['type'] = param.$type
//         jsonObj['attr'] = param.$
//         jsonObj['value'] = param._ !== undefined ? param._ : param.$.default // 有可能數值會有空字串('')
//         jsonObj['xmlObj'] = [] // 原意應為 parentGeometry
//         jsonObj['realXmlObj'] = param // XML object of parameter
//         if (param.$type == 'radio' || param.$type == "multi_selection") {
//             // jsonObj['option_list'] = param.option_list
//             let options = []
//             // check 'option_list' property
//             param.option_list.map(item => {
//                 let opList = []
//                 // check 'option' property
//                 if (item && item.option.length > 0) {
//                     item.option.map(op => {
//                         opList.push({
//                             attr: op.$,
//                             value: op._
//                         })
//                     })
//                 }
//                 options.push({ option: opList })
//             })
//             jsonObj['options'] = options
//         }
//         if (param.$type == "multi_string") {
//             // jsonObj['string_list'] = param.string_list
//             let strings = []
//             param.string_list.map(item => {
//                 strings.push({ string: item.string })
//             })
//             jsonObj['strings'] = strings
//         }
//         if (param.$type == 'dynamic_radio') {
//             // convert `option_list` to `options`
//             let options = []
//             if (param.option_list) {
//                 param.option_list.map(item => {
//                     let opList = []
//                     // check 'option' property
//                     if (item && item.option.length > 0) {
//                         item.option.map(op => {
//                             opList.push({
//                                 attr: op.$,
//                                 value: op._
//                             })
//                         })
//                     }
//                     options.push({ option: opList })
//                 })
//                 jsonObj['options'] = options
//             }
//             // convert `intersectional_option_list` to `intersection`
//             let intersection = []
//             if (param.intersectional_option_list) {
//                 param.intersectional_option_list.map(item => {
//                     let opList = []
//                     if (item && item.option.length > 0) {
//                         item.option.map(op => {
//                             opList.push({
//                                 attr: op.$
//                             })
//                         })
//                     }
//                     intersection.push({ option: opList })
//                 })
//                 jsonObj['intersection'] = intersection
//             }
//         }
//         return jsonObj
//     }
//     const getXmlObj = (gcid, layer, type, g) => {
//         if (gcid) {
//             return {
//                 geoCondId: gcid,
//                 layer,
//                 type,
//                 gid: g.$.id,
//                 value: _.cloneDeep(g)
//             }
//         } else {
//             return {
//                 layer,
//                 type,
//                 gid: g.$.id,
//                 value: _.cloneDeep(g)
//             }
//         }
//     }
//     // build root geo item from parameter list
//     let rootItem = { attr: cond.$, gid: "condition_root", type: "@root", parameters: [] }
//     if (cond.parameterList) {
//         // console.log('hl pList: ', cond.parameterList)
//         Object.keys(cond.parameterList).map(id => {
//             let p = cond.parameterList[id]
//             // rootItem.parameters.push({ 
//             //     pid: id, 
//             //     type: p.$type,
//             //     attr: p.$,
//             //     value: p._ 
//             // })
//             rootItem.parameters.push(getParamJson(p))
//         })
//     }
//     layout.geoItems.push(rootItem)
//     // build geo items from geo-condition list
//     if (cond.geoConditionList) {
//         Object.keys(cond.geoConditionList).map(id => {
//             let geoCond = cond.geoConditionList[id]
//             let geoItem = { 
//                 gid: geoCond.$.id, 
//                 attr: geoCond.$,
//                 isGeoCondition: true,
//                 degree: 1,
//                 parameters: [],
//                 geoGroup: []
//             }
//             if (geoCond.parameterList) {
//                 Object.keys(geoCond.parameterList).map(id => {
//                     let p = geoCond.parameterList[id]
//                     // geoItem.parameters.push({
//                     //     xmlObj: [],
//                     //     pid: id,
//                     //     type: p.$type,
//                     //     attr: p.$,
//                     //     value: p._
//                     // })
//                     geoItem.parameters.push(getParamJson(p))
//                 })
//             }
//             // check the geometry list
//             if (geoCond.geometryList) {
//                 const getGeoItemParameterList = (geom, showTitle, isMainTitle) => {
//                     let paramObjList = []
//                     // add title object
//                     if (showTitle) {
//                         let _type = isMainTitle ? "main_title" : "title"
//                         paramObjList.push({
//                             pid: geom.$.id,
//                             type: _type,
//                             attr: geom.$,
//                             value: null,
//                             xmlObj: []
//                         })
//                     }
//                     Object.keys(geom).map(prop => {
//                         let isParameter = paramType.find(it => { 
//                             return it == prop
//                         })
//                         if (isParameter) {
//                             // add title object
//                             // if (showTitle) {
//                             //     paramObjList.push({
//                             //         pid: geom.$.id,
//                             //         type: 'title',
//                             //         attr: geom.$,
//                             //         value: null,
//                             //         xmlObj: []
//                             //     })
//                             // }
//                             let parameterList = geom[prop]
//                             parameterList.map(param => {
//                                 let jsonObj = {} 
//                                 jsonObj['pid'] = param.$.id
//                                 jsonObj['type'] = prop
//                                 jsonObj['attr'] = param.$
//                                 jsonObj['value'] = param._ !== undefined ? param._ : param.$.default // 有可能數值會有空字串('')
//                                 jsonObj['xmlObj'] = [] // 原意應為 parentGeometry
//                                 jsonObj['realXmlObj'] = param // XML object of parameter
//                                 if (prop == 'radio' || prop == 'multi_selection') {
//                                     // jsonObj['option_list'] = param.option_list
//                                     let options = []
//                                     // check 'option_list' property
//                                     param.option_list.map(item => {
//                                         let opList = []
//                                         // check 'option' property
//                                         if (item && item.option.length > 0) {
//                                             item.option.map(op => {
//                                                 opList.push({
//                                                     attr: op.$,
//                                                     value: op._
//                                                 })
//                                             })
//                                         }
//                                         options.push({ option: opList })
//                                     })
//                                     jsonObj['options'] = options
//                                 }
//                                 if (prop == "multi_string") {
//                                     // jsonObj['string_list'] = param.string_list
//                                     let strings = []
//                                     param.string_list.map(item => {
//                                         strings.push({ string: item.string })
//                                     })
//                                     jsonObj['strings'] = strings
//                                 }
//                                 if (param.$type == 'dynamic_radio') {
//                                     // convert `option_list` to `options`
//                                     let options = []
//                                     if (param.option_list) {
//                                         param.option_list.map(item => {
//                                             let opList = []
//                                             // check 'option' property
//                                             if (item && item.option.length > 0) {
//                                                 item.option.map(op => {
//                                                     opList.push({
//                                                         attr: op.$,
//                                                         value: op._
//                                                     })
//                                                 })
//                                             }
//                                             options.push({ option: opList })
//                                         })
//                                         jsonObj['options'] = options
//                                     }
//                                     // convert `intersectional_option_list` to `intersection`
//                                     let intersection = []
//                                     if (param.intersectional_option_list) {
//                                         param.intersectional_option_list.map(item => {
//                                             let opList = []
//                                             if (item && item.option.length > 0) {
//                                                 item.option.map(op => {
//                                                     opList.push({
//                                                         attr: op.$
//                                                     })
//                                                 })
//                                             }
//                                             intersection.push({ option: opList })
//                                         })
//                                         jsonObj['intersection'] = intersection
//                                     }
//                                 }
//                                 // paramObjList.push({
//                                 //     xmlObj: [],
//                                 //     type: prop,
//                                 //     pid: param.$.id,
//                                 //     attr: param.$,
//                                 //     value: param._ ? param._ : param.$.default
//                                 // })
//                                 paramObjList.push(jsonObj)
//                             })
//                         }
//                     })
//                     return paramObjList
//                 }
//                 let keyList = Object.keys(geoCond.geometryList)
//                 if (keyList.length == 1) {
//                     let key = keyList[0]
//                     let g = geoCond.geometryList[key]
//                     //console.log('hl g: ', g)
//                     geoItem.type = g.$type
//                     let xmlObj_lyr1 = getXmlObj(geoCond.$.id, 1, g.$type, g)
//                     // let xmlObj_lyr1 = {
//                     //     layer: 1,
//                     //     gid: g.$.id,
//                     //     type: g.$type,
//                     //     value: g,
//                     //     geoCondId: geoCond.$.id
//                     // }
//                     let paramList_lyr1 = getGeoItemParameterList(g, true, true)
//                     paramList_lyr1.map(param => {
//                         param.xmlObj.push(xmlObj_lyr1)
//                         geoItem.parameters.push(param)
//                     })
//                     // the 2nd layer graph
//                     Object.keys(g).map(prop => {
//                         let isGeometry = geometryType.find(it => { 
//                             return it == prop
//                         })
//                         if (isGeometry) {
//                             let subGeomList = g[prop]
//                             subGeomList.map(subGeom => {
//                                 let paramList_lyr2 = getGeoItemParameterList(subGeom, true, false)
//                                 paramList_lyr2.map(param => {
//                                     let xmlObj_lyr2 = getXmlObj(undefined, 2, prop, subGeom)
//                                     // let xmlObj_lyr2 = {
//                                     //     layer: 2,
//                                     //     gid: subGeom.$.id,
//                                     //     type: prop,
//                                     //     value: subGeom
//                                     // }
//                                     param.xmlObj.push(xmlObj_lyr1)
//                                     param.xmlObj.push(xmlObj_lyr2)
//                                     geoItem.parameters.push(param)
//                                 })
//                             })
//                         }
//                     })
//                     // merge this graph to this geo-condition
//                     geoItem.value = g
//                     // Object.keys(g).map(prop => {
//                     //     // console.log('hl prop content: ', g[prop])
//                     //     // Check whether a property is a parameter
//                     //     let res = paramType.find(param => { 
//                     //         return param == prop
//                     //     })
//                     //     if (res) {
//                     //         let parameterList = g[prop]
//                     //         parameterList.map(param => {
//                     //             geoItem.parameters.push({
//                     //                 xmlObj: [{
//                     //                     layer: 1,
//                     //                     gid: g.$.id,
//                     //                     type: g.$type,
//                     //                     value: g
//                     //                 }],
//                     //                 type: prop,
//                     //                 pid: param.$.id,
//                     //                 attr: param.$,
//                     //                 value: param._ ? param._ : param.$.default
//                     //             })
//                     //         })
//                     //     }
//                     //     // Check whether a property is a geometry 
//                     //     res = geometryType.find(gType => { 
//                     //         return gType == prop
//                     //     }) 
//                     //     if (res) {
//                     //         let geometryList = g[prop]
//                     //         geometryList.map(geom => {
//                     //             console.log('hl geo type: ', prop, ', content: ', geom)
//                     //             Object.keys(geom).map(item => {
//                     //                 let res_ = paramType.find(param => { 
//                     //                     return param == item
//                     //                 })
//                     //                 if (res_) {
//                     //                     let parameterList_ = geom[item]
//                     //                     parameterList_.map(param_ => {
//                     //                         geoItem.parameters.push({
//                     //                             xmlObj: [{
//                     //                                 layer: 1,
//                     //                                 gid: g.$.id,
//                     //                                 type: g.$type,
//                     //                                 value: g
//                     //                             }, {
//                     //                                 layer: 2,
//                     //                                 gid: geom.$.id,
//                     //                                 type: prop,
//                     //                                 value: geom
//                     //                             }],
//                     //                             type: item,
//                     //                             pid: param_.$.id,
//                     //                             attr: param_.$,
//                     //                             value: param_._ ? param._ : param_.$.default
//                     //                         })
//                     //                     })
//                     //                 }
//                     //             })
//                     //         })
//                     //     }
//                     // })
//                 } else {
//                     // multiple graphs geo-condition
//                     geoItem.type = "@geoGroup"
//                     Object.keys(geoCond.geometryList).map(id => {
//                         let g = geoCond.geometryList[id]
//                         // the geo-item for multiple graphs
//                         let geoGroupItem = {
//                             type: g.$type,
//                             gid: g.$.id,
//                             attr: g.$,
//                             degree: 2,
//                             parameters: [],
//                             value: g,
//                             parent: geoCond.$.id,
//                             isGeoCondition: true
//                         }
//                         let xmlObj_lyr1 = getXmlObj(geoCond.$.id, 1, g.$type, g)
//                         // let xmlObj_lyr1 = {
//                         //     layer: 1,
//                         //     gid: g.$.id,
//                         //     type: g.$type,
//                         //     value: g,
//                         //     geoCondId: geoCond.$.id
//                         // }
//                         // add `xmlObj` to access the correct parameter
//                         let paramList_lyr1 = getGeoItemParameterList(g, false)
//                         paramList_lyr1.map(it => {
//                             it.xmlObj.push(xmlObj_lyr1)
//                             geoGroupItem.parameters.push(it)
//                         })
//                         // the 2nd layer graph
//                         Object.keys(g).map(prop => {
//                             let isGeometry = geometryType.find(it => { 
//                                 return it == prop
//                             })
//                             if (isGeometry) {
//                                 let subGeomList = g[prop]
//                                 subGeomList.map(subGeom => {
//                                     let paramList_lyr2 = getGeoItemParameterList(subGeom, true, false)
//                                     paramList_lyr2.map(param => {
//                                         let xmlObj_lyr2 = getXmlObj(undefined, 2, prop, subGeom)
//                                         // let xmlObj_lyr2 = {
//                                         //     layer: 2,
//                                         //     gid: subGeom.$.id,
//                                         //     type: prop,
//                                         //     value: subGeom
//                                         // }
//                                         param.xmlObj.push(xmlObj_lyr1)
//                                         param.xmlObj.push(xmlObj_lyr2)
//                                         geoGroupItem.parameters.push(param)
//                                     })
//                                 })
//                             }
//                         })
//                         geoItem.geoGroup.push(geoGroupItem)
//                     })
//                 }
//             }
//             layout.geoItems.push(geoItem)
//         })
//     }
//     // build geo items from geometry list
//     if (cond.geometryList) {
//         Object.keys(cond.geometryList).map(id => {
//             let geo = cond.geometryList[id]
//             let geoItem = { 
//                 gid: geo.$.id, 
//                 type: geo.$type,
//                 attr: geo.$,
//                 value: geo,
//                 isGeoCondition: false,
//                 degree: 1,
//                 parameters: [],
//                 geoGroup: []
//             }
//             layout.geoItems.push(geoItem)
//         })
//     }
//     return layout
// }


function createGeoCondObj(_ref) {
  var gcid = _ref.gcid,
      paramType = _ref.paramType,
      xmlObjList = _ref.xmlObjList;
  var gcObj = {
    geoCondId: gcid,
    paramXmlObj: {
      type: paramType,
      xmlObj: []
    }
  };

  if (xmlObjList) {
    gcObj.paramXmlObj.xmlObj = _.cloneDeep(xmlObjList);
  }

  return gcObj; // return {
  //     geoCondId: gcid,
  //     paramXmlObj: paramXmlObj ? paramXmlObj : {
  //         type: paramType,
  //         xmlObj: xmlObjList ? _.cloneDeep(xmlObjList) : []
  //     }
  // }
}
/**
 * @param {Object} query
 */


var addQuery = function addQuery(query) {
  var location = Object.assign({}, browserHistory.getCurrentLocation());
  Object.assign(location.query, query); // or simple replace location.query if you want to completely change params

  browserHistory.push(location);
}; // example
// () => addQuery({ paintRed: 1 })

/**
 * @param {...String} queryNames
 */


var removeQuery = function removeQuery() {
  var location = Object.assign({}, browserHistory.getCurrentLocation());

  for (var _len = arguments.length, queryNames = new Array(_len), _key = 0; _key < _len; _key++) {
    queryNames[_key] = arguments[_key];
  }

  queryNames.forEach(function (q) {
    return delete location.query[q];
  });
  browserHistory.push(location);
}; // example
// () => removeQuery('paintRed')


function getVmsProxyPort() {
  return _.get(JSON.parse(document.getElementById('initial-state').innerHTML || '{}'), 'envConfig.proxy.vmsProxyInfo.port');
}

function convertToFahrenheit(v) {
  return 9 / 5 * v + 32;
}

function convertToCelsius(v) {
  return (v - 32) * 5 / 9;
}

export { convertToCelsius, getConfig, // getConditionJson,
createGeoCondObj, addQuery, removeQuery, getVmsProxyPort, validateNumber, convertToFahrenheit };